/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */

import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import DropDown from '../../../assets/dropDownIcon.svg';
import LearnIcon from '../../../assets/learn.svg';
import FAQIcon from '../../../assets/help.svg';
import LogoutIcon from '../../../assets/logout.svg';
import MoneyBagIcon from '../../../assets/money-bag.svg';
import LoanStatementIcon from '../../../assets/loan-statement.svg';
import RightArrowIcon from '../../../assets/rightArrow.svg';
import EditProfileIcon from '../../../assets/edit-profile.svg';
import AboutUsIcon from '../../../assets/aboutusicon.svg';
import { useAuthStore, useDashboardStore } from '../../../redux';
import SettingsIcon from '../../../assets/auto-debit/settings-icon-nach-cancel.png';
import SettingsIcon2 from '../../../assets/auto-debit/settingIconNew.svg';
import { SecureClient } from '../../../utils';

export default function Pill({
  variant,
  label,
  emoji,
  notificationIcon,
  profilePic,
  userName,
  icon,
  altText,
  logoutClickHandler,
  pullChildDataFnc,
  ...rootDOMAttributes
}) {
  const navigate = useNavigate();
  const [isClicked, setClicked] = useState(false);
  const [
    isEligibleForSmartRepayCancellation,
    setIsEligibleForSmartRepayCancellation,
  ] = useState(false);
  const [isSettingClicked, setIsSettingClicked] = useState(false);

  const { customerId, customerRefNum, Authorization } = useAuthStore();

  const otherTabs = [
    {
      tabLabel: 'Settings',
      logo: SettingsIcon,
      altText: 'Settings',
      routeTo: '',
      path: '',
      onlyMobile: false,
      child: [
        {
          tablLabelName: 'Cancel Auto Debit',
          path: '/nach-cancellation/start',
        },
      ],
    },
  ];

  const dropDownClickHandler = () => {
    setClicked((isClicked) => !isClicked);
    if (isClicked) {
      pullChildDataFnc(false);
    } else {
      pullChildDataFnc(true);
    }
  };

  const logoutClicked = () => {
    logoutClickHandler && logoutClickHandler();
    setClicked((isClicked) => !isClicked);
    pullChildDataFnc(false);
  };

  const navigateToNotification = () => {
    navigate('/notification');
  };
  const { fibeCardActionTypes } = useDashboardStore();
  //for outsite click menu hide
  const ref = useRef();
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isClicked && ref.current && !ref.current.contains(e.target)) {
        setClicked(false);
        pullChildDataFnc(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isClicked]);

  const getNachStatusAPICallLocal = () => {
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/getnachstatus',
      headers: {
        Authorization,
      },
      payload: {
        customerRefNum,
      },
      successFn: (res) => {
        console.log('getNachStatusAPiI success', res);
        const { body, statusCode, statusMsg, statusDes } = res;
        const { autopaymentResponse } = body;
        const { isEligibleForEmandateCancellation } = autopaymentResponse;
        if (statusCode === 200) {
          setIsEligibleForSmartRepayCancellation(
            isEligibleForEmandateCancellation
          );
        }
      },
      errorFn: (err) => {
        console.log('getNachStatusAPiI error', err);
      },
      finallyFn: () => {
        console.log('Finally');
      },
    });
  };

  useEffect(() => {
    // getNachStatusAPICallLocal();
  }, []);

  const settingClickHandler = () => {
    setIsSettingClicked((prev) => !prev);
  };

  return (
    <div {...rootDOMAttributes} ref={ref}>
      {variant === 'profile' && (
        <div
          className="flex flex-col flex-wrap w-full gap-2 cursor-pointer"
          {...rootDOMAttributes}
        >
          <button
            id="userName"
            type="button"
            className={`text-sm font-semibold leading-[120%] py-2 px-4 border border-solid border-stroke rounded-[56px] [box-shadow:0px_11px_21px_rgba(0,0,0,0.07)]
                    text-text-dark align-baseline flex items-center ${
                      variant === 'profile' && 'bg-background-light'
                    }`}
            value={userName}
          >
            <img
              id="navigateToNotification"
              onClick={navigateToNotification}
              className="pr-5 w-[3.25rem] h-8 cursor-pointer"
              src={notificationIcon}
              alt="Bell icon for notification"
            />
            <div className="w-[1px] h-[30px] bg-background-stroke mr-4">
              &nbsp;
            </div>
            <span
              onClick={dropDownClickHandler}
              className="flex flex-row justify-center items-center "
            >
              <img
                id="profilePic"
                src={profilePic}
                alt="User's profile"
                className="p-1 mr-3 w-12 h-12 rounded-[50%]"
              />
              <p
                id="userName"
                className="pr-3 text-sm font-semibold leading-6 text-text-dark"
              >
                {' '}
                {userName}
              </p>
              <img
                id="dropDownIcon"
                src={DropDown}
                alt="Dropdown icon to view menu"
                className={` transition-all ${isClicked ? 'rotate-180' : ' '}`}
              />
            </span>
          </button>
          {isClicked && (
            <div
              className={`text-sm font-semibold leading-[120%] py-3 px-5 border border-solid border-stroke rounded-3xl [box-shadow:0px_12px_26px_rgba(0,0,0,0.12)]
            text-text-dark align-baseline flex flex-col relative z-[1] space-y-5 ${
              variant === 'profile' && 'bg-background-light'
            }`}
              style={{
                background: '#fff',
              }}
            >
              {/* <p>Logout</p> */}
              <Link
                id="loanStatement"
                to="/loan-statement"
                onClick={dropDownClickHandler}
              >
                <div className="flex items-center justify-between">
                  <div className="flex space-x-4 items-center">
                    <img
                      src={LoanStatementIcon}
                      alt="Document"
                      className="w-4 h-4"
                    />
                    <p>Loan statement</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to laon statement section"
                  />
                </div>
              </Link>
              <div id="learn" onClick={dropDownClickHandler}>
                <div
                  onClick={() =>
                    navigate('/learn', {
                      state: {
                        url: `https://portal-ec2.fibe.in/learn?src=mobile`,
                      },
                    })
                  }
                  className="flex items-center justify-between"
                >
                  <div className="flex space-x-4 items-center">
                    <img
                      src={LearnIcon}
                      alt="Book img to represent learn"
                      className="w-4 h-4"
                    />
                    <p>Learn</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to learn section"
                  />
                </div>
              </div>
              <Link
                id="upgradeyourlimi"
                to="/upgrade-your-limit"
                onClick={dropDownClickHandler}
              >
                <div className="flex items-center justify-between">
                  <div className="flex space-x-4 items-center">
                    <img
                      src={MoneyBagIcon}
                      alt="logout user"
                      className="w-4 h-4"
                    />
                    <p>Upgrade your limit</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to Upgrade your limit section"
                  />
                </div>
              </Link>
              {/* <Link id="fAQs" to="/faq" onClick={dropDownClickHandler}>
                <div className="flex items-center justify-between">
                  <div className="flex space-x-4 items-center">
                    <img
                      src={FAQIcon}
                      alt="Book img to represent about FAQs"
                      className="w-4 h-4"
                    />
                    <p>FAQs</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to Upgrade your limit section"
                  />
                </div>
              </Link> */}
              {/* Removed edit profile for phase1  */}
              <Link
                id="editprofile"
                to="/edit-profile"
                onClick={dropDownClickHandler}
              >
                <div className="flex items-center justify-between">
                  <div className="flex space-x-3 items-center">
                    <img
                      src={EditProfileIcon}
                      alt="user icon to rep edit user profile"
                      className="w-4 h-4"
                    />
                    <p>Edit profile</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to edit profile section"
                  />
                </div>
              </Link>

              <Link id="aboutus" to="/about-us" onClick={dropDownClickHandler}>
                <div className="flex items-center justify-between">
                  <div className="flex space-x-4 items-center">
                    <img
                      src={AboutUsIcon}
                      alt="user icon for about us section"
                      className="w-4 h-4"
                    />
                    <p>About us</p>
                  </div>
                  <img
                    src={RightArrowIcon}
                    alt="click to navigate to about us section"
                  />
                </div>
              </Link>
              {isEligibleForSmartRepayCancellation
                ? otherTabs.map((item) => (
                    <>
                      <div
                        className="flex items-center justify-between"
                        onClick={settingClickHandler}
                      >
                        <div className={`flex space-x-4 items-center`}>
                          <img
                            src={SettingsIcon2}
                            alt="user icon for about us section"
                            className="w-4 h-4"
                          />
                          <p>Setting</p>
                        </div>
                        <img
                          src={RightArrowIcon}
                          alt="click to navigate to about us section"
                          className={isSettingClicked ? 'rotate-90' : null}
                        />
                      </div>
                      {isSettingClicked
                        ? item.child?.map((childItem) => (
                            <Link to={childItem.path}>
                              <p className="text-[#999999] pl-10">
                                {childItem.tablLabelName}
                              </p>
                            </Link>
                          ))
                        : null}
                    </>
                  ))
                : null}

              <div
                id="logout"
                className="flex items-center justify-between"
                onClick={logoutClicked}
              >
                <div className="flex space-x-4 items-center">
                  <img src={LogoutIcon} alt="logout user" className="w-4 h-4" />
                  <p>Logout</p>
                </div>
                <img src={RightArrowIcon} alt="click to logout" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

Pill.propTypes = {
  variant: PropTypes.string.isRequired,
  label: PropTypes.string,
  emoji: PropTypes.string,
  notificationIcon: PropTypes.string,
  profilePic: PropTypes.string,
  userName: PropTypes.string,
  icon: PropTypes.string,
  altText: PropTypes.string,
};
